// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"vz_a bhe_b","TwoDimsListFeature__item":"vz_b bhe_ux","TwoDimsListFeature__item__text":"vz_c bhe_un"};